import React from "react";
import {Translate} from "react-localize-redux";
import {Button} from "antd";
import "./UnauthorizedView.scss";

const UnauthorizedView: React.FC = (): React.ReactElement => {
    const translatePath: string = "pages.UnauthorizedView.UnauthorizedView";

    return (
        <div className="df-403-view">
            <div className="df-403-icon-container"/>
            <div className="df-403-content">
                <h2><Translate id={`${translatePath}.403.text`}/></h2>
                <p><Translate id={`${translatePath}.pageAccess.text`}/></p>
                <p><Translate id={`${translatePath}.instruction.text`}/></p>
                <Button
                    type="primary"
                    onClick={(): void => window.history.back()}
                >
                    <Translate id={`${translatePath}.goBack.text`}/>
                </Button>
            </div>
        </div>
    );
};

export default UnauthorizedView;
